var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadset = function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19.2361V20C21 21.6569 19.6569 23 18 23H12C10.8954 23 10 22.1046 10 21C10 19.8954 10.8954 19 12 19C13.1046 19 14 19.8954 14 21H18C18.5523 21 19 20.5523 19 20H18C16.8954 20 16 19.1046 16 18V13C16 11.8954 16.8954 11 18 11H18.084C18.3845 6.18544 16.4184 4 11.9412 4C7.46601 4 5.53579 6.18077 5.90378 11H6C7.10457 11 8 11.8954 8 13V18C8 19.1046 7.10457 20 6 20H5C3.34315 20 2 18.6569 2 17V14C2 12.7258 2.79443 11.6371 3.91503 11.2022C3.4616 5.22373 6.22126 2 11.9412 2C17.6577 2 20.4525 5.2181 20.0739 11.1979C21.2003 11.6299 22 12.7216 22 14V17C22 17.8885 21.6137 18.6868 21 19.2361ZM4 14V17C4 17.5523 4.44772 18 5 18H6V13H5C4.44772 13 4 13.4477 4 14ZM18 13V18H19C19.5523 18 20 17.5523 20 17V14C20 13.4477 19.5523 13 19 13H18Z",
    fill: "currentColor"
  })));
};
export default SvgHeadset;